import createAwardsFacet from './product.awards';
import createCharacteristicsFacet from './product.characteristics';
import createClassificationFacet from './product.classification';
import createClosureType from './product.closureType';
import createCountries from './product.country';
import createDenominations from './product.denomination';
import createDesignationFacet from './product.designation';
import createBlendTypeFacet from './product.grapeVarieties/product.blendType';
import createGrapeVarietiesFacet from './product.grapeVarieties/product.grapeVarieties';
import createMainVarietyFacet from './product.grapeVarieties/product.mainVariety';
import createHighlights from './product.highlights';
// import createNameFacet from './product.name';
import createPrice from './product.price';
import createPriceRanges from './product.priceRange';
import createProductTypes from './product.productType';
import createRegions from './product.region';
import createRegionNames from './product.regionName';
import createRegionHierarchies from './product.regionHierarchy';
import createMainSoilTypeFacet from './product.soilTypes/product.mainSoilType';
import createSoilBlendTypeFacet from './product.soilTypes/product.soilBlendType';
import createSoilTypesFacet from './product.soilTypes/product.soilTypes';
import createSpecialClassification from './product.specialClassification';
import createSubregions from './product.subregion';
import createVintageFacet from './product.vintage';

/**
 * Facet creation. This will be called every time the state or config changes (basically on every rerender).
 * This file is meant to be customized per client - just return the filters that are used.
 *
 * The naming convention is to use the singular form of the attribute name
 * @param {object} config possible configuration from the ProductPage.
 * @param {object} state The current filter state from the productFilterReducer.
 */
export default function createFacets(config, state) {
  return {
    characteristics: createCharacteristicsFacet(config, state),
    classification: createClassificationFacet(config, state),
    specialClassifications: createSpecialClassification(config, state),
    country: createCountries(config, state),
    designation: createDesignationFacet(config, state),
    awards: createAwardsFacet(config, state),

    // Complex type for grape varieties
    grapeVarieties: createGrapeVarietiesFacet(config, state),
    mainVariety: createMainVarietyFacet(config, state),
    blendType: createBlendTypeFacet(config, state),

    // Complex type for soil types
    soilTypes: createSoilTypesFacet(config, state),
    mainSoilType: createMainSoilTypeFacet(config, state),
    soilBlendType: createSoilBlendTypeFacet(config, state),

    // name: createNameFacet(config, state),
    productType: createProductTypes(config, state),
    region: createRegions(config, state),
    subregion: createSubregions(config, state),
    regionName: createRegionNames(config, state),
    regionHierarchy: createRegionHierarchies(config, state),
    denomination: createDenominations(config, state),
    vintage: createVintageFacet(config, state),
    price: createPrice(config, state),
    closureTypes: createClosureType(config, state),
    highlights: createHighlights(config, state),
    priceRanges: createPriceRanges(config, state),
  };
}
